require('./vendor/slick.min');
require('./vendor/bootstrap-tooltip.js');
require('./vendor/jquery.fitvids.js');

require('./app/config');
require('./app/helpers');
require('./app/global');
require('./app/holster-finder');
require('./app/product-slider');
require('./app/image-carousel');

$('.quantity-input button').on('click', function(e){
  e.preventDefault();
  let $field = $(this).siblings('[type="number"]');
  let currentQty = Number($field.val());
  let minQty = Number($field.attr('min'));
  if ($(this).hasClass('increase')) {
    $field.val(currentQty + 1).trigger('change');
  } else {
    let newQty = currentQty - 1;
    if (newQty >= minQty) {
      $field.val(newQty).trigger('change');
    }
  }
});

$('.quantity-input input').on('change', function(e){
  if ($('#cart-footer').length) {
    $('[name="update"]').show();
    $('[name="checkout"]').hide();
  }
});


$('.quotes .items').slick({
  dots: true,
  arrows: false,
  fade: true
});

// expand/collapse filters for mobile
$b.on('click', '#show-filters', function(e){
  e.preventDefault();
  $('#collection-filters .expandable-panel').removeClass('is-expanded'); // show collapsed by default
  $('#collection-filters').addClass('shown');
  $(this).hide();
  $('#hide-filters').show();
});
$b.on('click', '#hide-filters', function(e){
  e.preventDefault();
  $('#collection-filters').removeClass('shown');
  $(this).hide();
  $('#show-filters').show();
});

$('.cards-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  dots: true,
  variableWidth: true,
  arrows: false
});